import { ArrowRight } from "lucide-react";
import { config } from "../config/siteConfig";
import { openLeadForm } from "../lib/leadForm";

const CtaButton = ({ variant = "gold", size = "lg", testid = "cta-button", className = "", label }) => {
  const text = label || config.cta.primary;

  const handleClick = (e) => {
    e.preventDefault();
    openLeadForm(testid.replace(/-cta-button$/, ""));
  };

  const base =
    "group inline-flex items-center justify-center gap-3 font-mono uppercase tracking-[0.18em] font-medium transition-[transform,background-color,color,box-shadow] duration-300 will-change-transform";
  const sizes = {
    lg: "px-8 sm:px-10 py-4 sm:py-5 text-xs sm:text-sm",
    md: "px-6 py-3 text-[11px] sm:text-xs",
  };
  const variants = {
    gold:
      "bg-[#D4AF37] text-[#08162B] hover:bg-white hover:text-[#08162B] hover:-translate-y-0.5 shadow-[0_20px_50px_-15px_rgba(212,175,55,0.45)]",
    light:
      "bg-white text-[#08162B] hover:bg-[#D4AF37] hover:text-[#08162B] hover:-translate-y-0.5 shadow-[0_20px_50px_-15px_rgba(0,0,0,0.5)]",
    navy:
      "bg-[#08162B] text-white hover:bg-[#12294D] hover:-translate-y-0.5 shadow-[0_20px_50px_-20px_rgba(8,22,43,0.6)]",
    outline:
      "border border-white/30 text-white hover:bg-white hover:text-[#08162B] hover:-translate-y-0.5",
  };

  return (
    <a
      href="#get-the-book"
      onClick={handleClick}
      data-testid={testid}
      className={`${base} ${sizes[size]} ${variants[variant]} ${className}`}
    >
      <span>{text}</span>
      <ArrowRight
        size={16}
        className="transition-transform duration-300 group-hover:translate-x-1"
      />
    </a>
  );
};

export default CtaButton;
